import { useObserver } from "mobx-react";
import { TbPointFilled } from "react-icons/tb";
import { useStores } from "../../store/index";
const Language = () => {

    const { ResumeStore } = useStores();

    const levelPercentage = (level) => {
        if (level === "native speaker") {
            return "w-[35%]";
        }
        else if (level === "highly proficient") {
            return "w-[70%]";
        }
        else {
            return "w-[100%]";
        }
    }



    return useObserver(() => (
        <div className=" flex flex-col items-center justify-center  w-[80%] mx-auto my-5 md:mt-8 lg:mt-10 ">
            {ResumeStore.resumeBuilder.languages.length > 0 && <h1 id="education"
                // style={{ borderColor: ResumeStore.resumeBuilder?.primaryColor }}
                className="blackh1">Languages</h1>}
            <div className="flex text-white flex-col items-start my-2 gap-1 w-[70%] mx-auto text-sm ">

                {ResumeStore.resumeBuilder.languages.map((item, index) => (
                    <>
                        <div className="flex justify-center items-center ">
                            <TbPointFilled className="mr-1" />
                            <p className="text-white text-sm">{item?.language}</p>

                        </div>
                        <div className=" relative bg-gray-500 h-[5px] w-full rounded-full">
                            <div className={`absolute rounded-full bg-resume_primary h-[5px] ${levelPercentage(item?.level)}  `}></div>
                        </div>
                    </>

                ))}



            </div>


        </div>
    ));
}

export default Language;